import type { UseCurriculum_AcademicEventFragment as AcademicEvent } from 'bundles/degree-home/components/v3-dpm/lib/__queries__/__generated__/dpmSharedFragments';
import useCalendarEvents from 'bundles/degree-home/components/v3-dpm/lib/useCalendarEvents';

const useNudge = () => {
  const calenderEventsGql = useCalendarEvents();

  const academicEvents = (calenderEventsGql?.data?.Degree?.queryById?.events?.filter(
    (event) => event.__typename === 'DegreeEvent_AcademicEvent'
  ) ?? []) as AcademicEvent[];

  const currentDate = Date.now();

  const displayableEvents = academicEvents.filter(
    (event) =>
      event.displayStartDate &&
      event.displayEndDate &&
      new Date(event.displayStartDate).getTime() <= currentDate &&
      new Date(event.displayEndDate).getTime() >= currentDate
  );

  return displayableEvents;
};

export default useNudge;
